export const Comment = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.8315 9.5H14.5C15.4205 9.5 16.1667 8.75381 16.1667 7.83333V2.41667C16.1667 1.49619 15.4205 0.75 14.5 0.75H5.95833C5.03786 0.75 4.29167 1.49619 4.29167 2.41667V4.08333M11.1667 4.08333H2.41667C1.49619 4.08333 0.75 4.82953 0.75 5.75V11.1667C0.75 12.0871 1.49619 12.8333 2.41667 12.8333H3.45833V14.9167L7.20833 12.8333H11.1667C12.0871 12.8333 12.8333 12.0871 12.8333 11.1667V5.75C12.8333 4.82953 12.0871 4.08333 11.1667 4.08333Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Comment
